import { productionHref, productionLocale } from './production-locale';

/** The 29 distinct page identities are stable across all country/language URLs. */
export const APPROVED_PAGE_IDS = ['home', 'games', 'download', 'support', 'servers', 'technology', 'ping-reduction', 'packet-loss', 'disconnect-correction', 'ping-spikes-correction', 'boost-fps', 'keyboard-speed-enhancement', 'comprehensive-statistics', 'connection-monitoring', 'manual-server', 'ip-block', 'calculation-of-route', 'dns-optimization', 'automatic-game', 'freeze-correction', 'rollback-correction', 'lag-correction', 'wrong-server-selected', 'artificial-intelligence', 'audiopad', 'aim-trainer', 'pro-settings', 'replay-x', 'mobile'] as const;

export type ApprovedPageId = (typeof APPROVED_PAGE_IDS)[number];

const MAIN_PAGES = new Set<string>(['games', 'download', 'support', 'servers', 'technology']);

export function approvedPageRoute(pageId: string): string | null {
  if (pageId === 'home') return '';
  if (!APPROVED_PAGE_IDS.some((id) => id === pageId)) return null;
  return MAIN_PAGES.has(pageId) ? `/${pageId}` : `/features/${pageId}`;
}

export function approvedPageIdFromSegments(segments: string[]): ApprovedPageId | null {
  const route = segments.length ? `/${segments.join('/')}` : '';
  return APPROVED_PAGE_IDS.find((id) => approvedPageRoute(id) === route) ?? null;
}

export function approvedPageHref(prefix: string, pageId: string): string | null {
  const route = approvedPageRoute(pageId);
  return route === null ? null : `${prefix}${route}`;
}

/** Operational pages (trial, tutorials, login...) are outside the 29 editorial routes: their locale is the production one. */
export function approvedOperationalLocale(group: string): string {
  return productionLocale(group);
}

/** Operational/legacy path → its production URL (https://noping.com/<locale><path>), never a staging locale route. */
export function approvedOperationalHref(group: string, pathname: string): string {
  return productionHref(group, pathname);
}
